import FirmDetailsCard from "@/components/features/settings/firm/FirmDetailsCard";
import FirmOfficesCard from "@/components/features/settings/firm/FirmOfficesCard";
import FirmTestButtonsCard from "@/components/features/settings/firm/FirmTestButtonsCard";
import { GlobalNotAuthorized } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/settings/firm")({
  component: RouteComponent,
});

function RouteComponent() {
  const { hasPagePermission } = useUser();

  if (!hasPagePermission(PAGE_PERMISSION_KEYS.firmMyFirm)) {
    return <GlobalNotAuthorized />;
  }

  return (
    <div className="flex flex-col gap-6">
      <FirmDetailsCard />
      <FirmOfficesCard />
      <FirmTestButtonsCard />
    </div>
  );
}
